module.exports = __webpack_public_path__ + "static/media/blond.bf641287.png";